import { packIntoFormData } from "../utilities/apiUtilities";
import axiosInstance from "../auth/axioInstance";
const controllerUrl = `/show`



function createShow(showCreateViewModel) {

    console.log(showCreateViewModel)
    //return
    return axiosInstance.post(`${controllerUrl}`, showCreateViewModel, { headers: { 'Content-Type': "multipart/form-data"} });
}

function indexShows({
    sortOrder = "", 
    searchString = "", 
    pageSize = 50, 
    pageNumber = 1
}) {
    
    
    // return axios.get(`${controllerUrl}`, { params: {sortOrder: sortOrder, searchString: searchString, pageSize: pageSize, pageNumber: pageNumber}});
  return axiosInstance.get(`${controllerUrl}`, { params: {sortOrder: sortOrder, searchString: searchString, pageSize: pageSize, pageNumber: pageNumber}});
}

function getShow(id) {
    return axiosInstance.get(`${controllerUrl}/${id}`);
}

function updateShow(id, showCreateViewModel) {
     return axiosInstance.put(`${controllerUrl}/${id}`, showCreateViewModel, { headers: { 'Content-Type': "multipart/form-data"} })

}

function deleteShow(id) {
    return axiosInstance.delete(`${controllerUrl}/${id}`);
}

export const showService = {
    createShow,
    indexShows,
    getShow,
    updateShow,
    deleteShow
}